






































import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import {Grid} from '@toast-ui/vue-grid';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
import {i18nAllObject} from '@/utils/i18n';
import {getDownToday} from '@/utils/dateUtils';
import {writeExcel} from '@/utils/excel';

interface PageObj {
  page: number;
}

@Component({
  components: {CompSelectBox}
})
export default class GridTable extends Vue {
  @Prop({default: true})
  private haveRigthBtn?: boolean;
  @Prop({default: true})
  private haveConfigBtn?: boolean;
  @Prop({default: true})
  private havePageSizeBtn?: boolean;
  @Prop({default: true})
  private haveExcelDownBtn?: boolean;

  @Prop({default: true})
  private onLoadSearch?: boolean;

  @Prop({required: true})
  private gridProps!: any;

  @Prop({required: true})
  private data!: [];

  @Prop({default: 0})
  private totalCount!: number;

  @Prop()
  private excelDownInfo?: any;

  @Prop()
  private cntTitle?: string;
  private get tableTitle() {
    if (this.cntTitle) {
      return this.$t(this.cntTitle);
    } else {
      return this.$t('COMMON_VIEWRESULTS');
    }
  }

  private pageSize = '30';

  private pageSizes = [
    {value: '30', label: 'COMMON_PAGE_SIZE_30'},
    {value: '50', label: 'COMMON_PAGE_SIZE_50'},
    {value: '100', label: 'COMMON_PAGE_SIZE_100'},
    {value: '200', label: 'COMMON_PAGE_SIZE_200'}
  ];

  private changePageSize(value: any) {
    this.$emit('searchBtnClick', 1, Number(value));
  }
  @Watch('data')
  onDataChanged() {
    const grid = this.$refs.tuiGrid as Grid;
    const pagination = grid.invoke('getPagination') as any;
    grid.invoke('setBodyHeight', this.data.length === 0 ? 190 : 480);

    let dataRenderInfo: any = [];

    this.data.map((item: any) => {
      if (item.platformTypeLabel === 'MOBILE WEB') {
        item.platformTypeLabel = '모바일 웹';
      }
      dataRenderInfo.push(item);
    });

    let judgeUrlData: any = this.$route.fullPath === '/order/list/pay-fail' ? dataRenderInfo : this.data;

    if (pagination) {
      const pageState = {
        totalCount: this.totalCount,
        page: this.gridProps.options.pageOptions.page,
        perPage: Number(this.pageSize)
      };
      grid.invoke('resetData', judgeUrlData as any, {pageState});
    } else {
      grid.invoke('resetData', judgeUrlData as any);
    }
  }

  private excelDown() {
    // reset Excel form
    // Judge URL
    if (this.$route.fullPath === '/order/list/pay-fail') {
      let dataInfo: any = [];
      this.data.map((item: any) => {
        if (item.platformTypeLabel === 'MOBILE WEB') {
          item.platformTypeLabel = '모바일 웹';
        }
        if (item.taskMessage === false) {
          item.taskMessage = '';
        }
        dataInfo.push(item);
      });

      if (this.data && this.data.length > 0) {
        let columns = i18nAllObject(this, this.excelDownInfo.columns);
        // Copy a new object
        let columnsFilter: any = {...columns};
        // Change the key want to change
        columnsFilter.orderStatusType = '결제실패구분';

        writeExcel(dataInfo, columnsFilter, this.excelDownInfo.fileName + '_' + getDownToday(), this.excelDownInfo.formatters);
      } else {
        alert(this.$t('COMMON_NOT_DATA'));
      }
    } else {
      if (this.data && this.data.length > 0) {
        let columns = i18nAllObject(this, this.excelDownInfo.columns);
        writeExcel(this.data, columns, this.excelDownInfo.fileName + '_' + getDownToday(), this.excelDownInfo.formatters);
      } else {
        alert(this.$t('COMMON_NOT_DATA'));
      }
    }
  }

  private getCheckedRowKeys() {
    return (this.$refs.tuiGrid as Grid).invoke('getCheckedRowKeys');
  }
  private getRowAt(key: any) {
    return (this.$refs.tuiGrid as Grid).invoke('getRowAt', key);
  }
  private getCheckedRows() {
    return (this.$refs.tuiGrid as Grid).invoke('getCheckedRows');
  }
  private getData() {
    return (this.$refs.tuiGrid as Grid).invoke('getData');
  }
  private getElement(rowKey: any, columnName: any) {
    return (this.$refs.tuiGrid as Grid).invoke('getElement', rowKey, columnName);
  }
  private disableRowCheck(rowKey: any) {
    return (this.$refs.tuiGrid as Grid).invoke('disableRowCheck', rowKey);
  }
  private getRow(rowKey: any) {
    return (this.$refs.tuiGrid as Grid).invoke('getRow', rowKey);
  }

  private getCheckedItems(propName: string) {
    const grid = this.$refs.tuiGrid as Grid;
    const items = grid.invoke('getCheckedRows').map(item => item[propName]);
    return items.join(',');
  }

  private mounted() {
    const grid = this.$refs.tuiGrid as Grid;
    const pagination = grid.invoke('getPagination');
    // delete attr(title)
    $('.tui-grid-column-resize-handle').removeAttr('title');
    if (pagination) {
      grid.invoke('on', 'beforePageMove', (ev: any) => {
        this.$emit('searchBtnClick', ev.page);
        ev.stop();
      });
    }
    grid.invoke('on', 'mousedown', (ev: any) => {
      ev.stop();
    });
    if (this.onLoadSearch) {
      this.$emit('searchBtnClick', 1);
    }
  }
}
